import { useEffect } from "react";
import { Connexion } from "./auth/Connexion.js";
import { useSession } from "./auth/session.store.js";
import { Station } from "./station/Station.js";

/**
 * Le portier. Trois etats et pas deux : « inconnu » est celui du premier
 * instant, avant que `/api/auth/me` ait repondu. Le confondre avec « anonyme »
 * ferait clignoter l'ecran de connexion a chaque ouverture, y compris pour
 * quelqu'un de deja connecte.
 *
 * Ce n'est PAS la protection : elle est cote API, sur chaque route, ou la garde
 * refuse par defaut. Ceci n'est que l'interface qui va avec.
 */
export function App(): JSX.Element {
  const etat = useSession((magasin) => magasin.etat);
  const rafraichir = useSession((magasin) => magasin.rafraichir);

  useEffect(() => {
    void rafraichir();
  }, [rafraichir]);

  if (etat === "inconnu") return <div className="attente">Ouverture de la session…</div>;
  if (etat === "anonyme") return <Connexion />;
  // Un seul ecran : la station. La bibliotheque et l'editeur existent encore
  // dans le depot mais plus rien ne les atteint — voir `editeur/Editeur.tsx`.
  return <Station />;
}
